import { usePostHog } from "posthog-js/react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { fetchHiredlyXContent } from "../../../redux/actions/company_action";
import {
  ButtonStyled,
  CardImage,
  CardListContainer,
  CardText,
  CardTextContainer,
  GridContainerStyled,
} from "./styles";

let query = `
  firstCardSection{
      title
      subtitle
      coverImage {
        data {
          attributes {
            url
          }
        }
      }
  }
`;

export default function HXHeader(props) {
  const { onScrollToPackage } = props;
  const [solutions, setSolutions] = useState([]);

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  async function fetchData() {
    const response = await dispatch(fetchHiredlyXContent(query));

    const { firstCardSection } = response || {};
    setSolutions(firstCardSection);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const buttonCTA = "Book A Free Consultation";
  const buttonColour = "yellow";
  const posthog = usePostHog();

  function triggerInfoDialog() {
    onScrollToPackage();
  }

  return (
    <GridContainerStyled id={"solutions-content"} ref={containerRef}>
      <CardListContainer>
        <CardTextContainer>
          <CardText
            component="h1"
            type={"title"}
            dangerouslySetInnerHTML={{ __html: solutions?.title }}
          ></CardText>
          <CardText
            type={"desc"}
            dangerouslySetInnerHTML={{ __html: solutions?.subtitle }}
          ></CardText>

          <ButtonStyled onClick={triggerInfoDialog}>{buttonCTA}</ButtonStyled>
        </CardTextContainer>

        <CardImage src={solutions?.coverImage?.data?.attributes?.url} />
      </CardListContainer>
    </GridContainerStyled>
  );
}
